import { render, staticRenderFns } from "./AccountBoxMultiple.vue?vue&type=template&id=6d8c5ceb"
import script from "./AccountBoxMultiple.vue?vue&type=script&lang=js"
export * from "./AccountBoxMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports